// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Z2ZyL","label":"styles_label__1qz5Z"};